module.exports = __webpack_public_path__ + "media/images/price_list/feature-2-1029bc7e692c08f7763c46bcacfcb2ce.webp";